var cov_g3l39j7ue = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/hoc/coin.tsx",
      hash = "cfef2681cbedded1ffb6a621462a990cf531f90d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/hoc/coin.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 62
        },
        end: {
          line: 90,
          column: 53
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 90,
          column: 53
        }
      },
      "2": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 18
        }
      },
      "3": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 24,
          column: 7
        }
      },
      "4": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 52
        }
      },
      "5": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 50
        }
      },
      "6": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 60
        }
      },
      "7": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 56
        }
      },
      "8": {
        start: {
          line: 33,
          column: 27
        },
        end: {
          line: 33,
          column: 37
        }
      },
      "9": {
        start: {
          line: 34,
          column: 24
        },
        end: {
          line: 34,
          column: 34
        }
      },
      "10": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 37,
          column: 7
        }
      },
      "11": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 94
        }
      },
      "12": {
        start: {
          line: 36,
          column: 46
        },
        end: {
          line: 36,
          column: 93
        }
      },
      "13": {
        start: {
          line: 36,
          column: 84
        },
        end: {
          line: 36,
          column: 92
        }
      },
      "14": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 31
        }
      },
      "15": {
        start: {
          line: 38,
          column: 23
        },
        end: {
          line: 38,
          column: 31
        }
      },
      "16": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 47
        }
      },
      "17": {
        start: {
          line: 43,
          column: 26
        },
        end: {
          line: 43,
          column: 36
        }
      },
      "18": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 25
        }
      },
      "19": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 40
        }
      },
      "20": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 29
        }
      },
      "21": {
        start: {
          line: 46,
          column: 19
        },
        end: {
          line: 46,
          column: 29
        }
      },
      "22": {
        start: {
          line: 50,
          column: 25
        },
        end: {
          line: 50,
          column: 35
        }
      },
      "23": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 26
        }
      },
      "24": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 39
        }
      },
      "25": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 27
        }
      },
      "26": {
        start: {
          line: 53,
          column: 18
        },
        end: {
          line: 53,
          column: 27
        }
      },
      "27": {
        start: {
          line: 57,
          column: 30
        },
        end: {
          line: 57,
          column: 40
        }
      },
      "28": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 27
        }
      },
      "29": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 40
        }
      },
      "30": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 37
        }
      },
      "31": {
        start: {
          line: 60,
          column: 23
        },
        end: {
          line: 60,
          column: 37
        }
      },
      "32": {
        start: {
          line: 64,
          column: 28
        },
        end: {
          line: 64,
          column: 38
        }
      },
      "33": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 67,
          column: 7
        }
      },
      "34": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 41
        }
      },
      "35": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 28
        }
      },
      "36": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 33
        }
      },
      "37": {
        start: {
          line: 69,
          column: 21
        },
        end: {
          line: 69,
          column: 33
        }
      },
      "38": {
        start: {
          line: 73,
          column: 58
        },
        end: {
          line: 73,
          column: 68
        }
      },
      "39": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 76
        }
      },
      "40": {
        start: {
          line: 75,
          column: 17
        },
        end: {
          line: 75,
          column: 76
        }
      },
      "41": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 77,
          column: 67
        }
      },
      "42": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 67
        }
      },
      "43": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 88,
          column: 7
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 16
          },
          end: {
            line: 10,
            column: 17
          }
        },
        loc: {
          start: {
            line: 10,
            column: 62
          },
          end: {
            line: 90,
            column: 53
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 62
          },
          end: {
            line: 10,
            column: 63
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 90,
            column: 53
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        },
        loc: {
          start: {
            line: 20,
            column: 34
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 5
          }
        },
        loc: {
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 40,
            column: 5
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 36,
            column: 41
          },
          end: {
            line: 36,
            column: 42
          }
        },
        loc: {
          start: {
            line: 36,
            column: 46
          },
          end: {
            line: 36,
            column: 93
          }
        },
        line: 36
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 36,
            column: 78
          },
          end: {
            line: 36,
            column: 79
          }
        },
        loc: {
          start: {
            line: 36,
            column: 84
          },
          end: {
            line: 36,
            column: 92
          }
        },
        line: 36
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        loc: {
          start: {
            line: 42,
            column: 62
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 42
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        loc: {
          start: {
            line: 49,
            column: 54
          },
          end: {
            line: 54,
            column: 5
          }
        },
        line: 49
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        loc: {
          start: {
            line: 56,
            column: 66
          },
          end: {
            line: 61,
            column: 5
          }
        },
        line: 56
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        loc: {
          start: {
            line: 63,
            column: 64
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 63
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        loc: {
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 89,
            column: 5
          }
        },
        line: 72
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 37,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 37,
            column: 7
          }
        }, {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 37,
            column: 7
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 35,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 35,
            column: 18
          }
        }, {
          start: {
            line: 35,
            column: 23
          },
          end: {
            line: 35,
            column: 28
          }
        }, {
          start: {
            line: 35,
            column: 32
          },
          end: {
            line: 35,
            column: 43
          }
        }],
        line: 35
      },
      "2": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 31
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 31
          }
        }],
        line: 38
      },
      "3": {
        loc: {
          start: {
            line: 39,
            column: 16
          },
          end: {
            line: 39,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 16
          },
          end: {
            line: 39,
            column: 21
          }
        }, {
          start: {
            line: 39,
            column: 25
          },
          end: {
            line: 39,
            column: 27
          }
        }],
        line: 39
      },
      "4": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 29
          }
        }, {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 29
          }
        }],
        line: 46
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 27
          }
        }, {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 27
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 37
          }
        }, {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 37
          }
        }],
        line: 60
      },
      "7": {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }, {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }],
        line: 65
      },
      "8": {
        loc: {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 24
          }
        }, {
          start: {
            line: 65,
            column: 28
          },
          end: {
            line: 65,
            column: 41
          }
        }],
        line: 65
      },
      "9": {
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 33
          }
        }, {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 33
          }
        }],
        line: 69
      },
      "10": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 76
          }
        }, {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 76
          }
        }],
        line: 75
      },
      "11": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 77,
            column: 67
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 77,
            column: 67
          }
        }, {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 77,
            column: 67
          }
        }],
        line: 76
      },
      "12": {
        loc: {
          start: {
            line: 76,
            column: 10
          },
          end: {
            line: 76,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 10
          },
          end: {
            line: 76,
            column: 30
          }
        }, {
          start: {
            line: 76,
            column: 34
          },
          end: {
            line: 76,
            column: 62
          }
        }],
        line: 76
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/hoc/coin.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
export default (function (coinType) {
  cov_g3l39j7ue.f[0]++;
  cov_g3l39j7ue.s[0]++;
  return function (Origin) {
    var _class, _temp;

    cov_g3l39j7ue.f[1]++;
    cov_g3l39j7ue.s[1]++;
    return _temp = _class =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(Coin, _PureComponent);

      var _super = _createSuper2(Coin);

      function Coin(props) {
        var _this;

        _classCallCheck(this, Coin);

        cov_g3l39j7ue.f[2]++;
        cov_g3l39j7ue.s[2]++;
        _this = _super.call(this, props);
        _this.isFocus = void 0;
        _this.mouseDown = void 0;
        cov_g3l39j7ue.s[3]++;
        _this.state = {
          showCoin: props.coin
        };
        cov_g3l39j7ue.s[4]++;
        _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
        cov_g3l39j7ue.s[5]++;
        _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
        cov_g3l39j7ue.s[6]++;
        _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
        cov_g3l39j7ue.s[7]++;
        _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(Coin, [{
        key: "getValue",
        value: function getValue() {
          cov_g3l39j7ue.f[3]++;

          var _ref = (cov_g3l39j7ue.s[8]++, this.state),
              showCoin = _ref.showCoin;

          var _ref2 = (cov_g3l39j7ue.s[9]++, this.props),
              value = _ref2.value;

          cov_g3l39j7ue.s[10]++;

          if ((cov_g3l39j7ue.b[1][0]++, showCoin) && ((cov_g3l39j7ue.b[1][1]++, value) || (cov_g3l39j7ue.b[1][2]++, value === 0))) {
            cov_g3l39j7ue.b[0][0]++;
            cov_g3l39j7ue.s[11]++;
            return "".concat(value).replace(/\d+/, function (n) {
              cov_g3l39j7ue.f[4]++;
              cov_g3l39j7ue.s[12]++;
              return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                cov_g3l39j7ue.f[5]++;
                cov_g3l39j7ue.s[13]++;
                return "".concat($1, ",");
              });
            });
          } else {
            cov_g3l39j7ue.b[0][1]++;
          }

          cov_g3l39j7ue.s[14]++;

          if (value === 0) {
            cov_g3l39j7ue.b[2][0]++;
            cov_g3l39j7ue.s[15]++;
            return 0;
          } else {
            cov_g3l39j7ue.b[2][1]++;
          }

          cov_g3l39j7ue.s[16]++;
          return "".concat((cov_g3l39j7ue.b[3][0]++, value) || (cov_g3l39j7ue.b[3][1]++, '')).replace(/,/g, '');
        }
      }, {
        key: "handleFocus",
        value: function handleFocus(e) {
          cov_g3l39j7ue.f[6]++;

          var _ref3 = (cov_g3l39j7ue.s[17]++, this.props),
              onFocus = _ref3.onFocus;

          cov_g3l39j7ue.s[18]++;
          this.isFocus = true;
          cov_g3l39j7ue.s[19]++;
          this.setState({
            showCoin: false
          });
          cov_g3l39j7ue.s[20]++;

          if (onFocus) {
            cov_g3l39j7ue.b[4][0]++;
            cov_g3l39j7ue.s[21]++;
            onFocus(e);
          } else {
            cov_g3l39j7ue.b[4][1]++;
          }
        }
      }, {
        key: "handleBlur",
        value: function handleBlur(e) {
          cov_g3l39j7ue.f[7]++;

          var _ref4 = (cov_g3l39j7ue.s[22]++, this.props),
              onBlur = _ref4.onBlur;

          cov_g3l39j7ue.s[23]++;
          this.isFocus = false;
          cov_g3l39j7ue.s[24]++;
          this.setState({
            showCoin: true
          });
          cov_g3l39j7ue.s[25]++;

          if (onBlur) {
            cov_g3l39j7ue.b[5][0]++;
            cov_g3l39j7ue.s[26]++;
            onBlur(e);
          } else {
            cov_g3l39j7ue.b[5][1]++;
          }
        }
      }, {
        key: "handleMouseDown",
        value: function handleMouseDown(e) {
          cov_g3l39j7ue.f[8]++;

          var _ref5 = (cov_g3l39j7ue.s[27]++, this.props),
              onMouseDown = _ref5.onMouseDown;

          cov_g3l39j7ue.s[28]++;
          this.mouseDown = true;
          cov_g3l39j7ue.s[29]++;
          this.setState({
            showCoin: false
          });
          cov_g3l39j7ue.s[30]++;

          if (onMouseDown) {
            cov_g3l39j7ue.b[6][0]++;
            cov_g3l39j7ue.s[31]++;
            onMouseDown(e);
          } else {
            cov_g3l39j7ue.b[6][1]++;
          }
        }
      }, {
        key: "handleMouseUp",
        value: function handleMouseUp(e) {
          cov_g3l39j7ue.f[9]++;

          var _ref6 = (cov_g3l39j7ue.s[32]++, this.props),
              onMouseUp = _ref6.onMouseUp;

          cov_g3l39j7ue.s[33]++;

          if ((cov_g3l39j7ue.b[8][0]++, this.mouseDown) && (cov_g3l39j7ue.b[8][1]++, !this.isFocus)) {
            cov_g3l39j7ue.b[7][0]++;
            cov_g3l39j7ue.s[34]++;
            this.setState({
              showCoin: true
            });
          } else {
            cov_g3l39j7ue.b[7][1]++;
          }

          cov_g3l39j7ue.s[35]++;
          this.mouseDown = false;
          cov_g3l39j7ue.s[36]++;

          if (onMouseUp) {
            cov_g3l39j7ue.b[9][0]++;
            cov_g3l39j7ue.s[37]++;
            onMouseUp(e);
          } else {
            cov_g3l39j7ue.b[9][1]++;
          }
        }
      }, {
        key: "render",
        value: function render() {
          cov_g3l39j7ue.f[10]++;

          var _ref7 = (cov_g3l39j7ue.s[38]++, this.props),
              coin = _ref7.coin,
              value = _ref7.value,
              onFocus = _ref7.onFocus,
              onBlur = _ref7.onBlur,
              others = _objectWithoutProperties(_ref7, ["coin", "value", "onFocus", "onBlur"]);

          cov_g3l39j7ue.s[39]++;

          if (!coin) {
            cov_g3l39j7ue.b[10][0]++;
            cov_g3l39j7ue.s[40]++;
            return (
              /*#__PURE__*/
              React.createElement(Origin, Object.assign({}, this.props, {
                coin: undefined,
                __self: this,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 75,
                  columnNumber: 25
                }
              }))
            );
          } else {
            cov_g3l39j7ue.b[10][1]++;
          }

          cov_g3l39j7ue.s[41]++;

          if ((cov_g3l39j7ue.b[12][0]++, coinType === 'input') && (cov_g3l39j7ue.b[12][1]++, this.props.type !== 'number')) {
            cov_g3l39j7ue.b[11][0]++;
            cov_g3l39j7ue.s[42]++;
            return (
              /*#__PURE__*/
              React.createElement(Origin, Object.assign({}, this.props, {
                coin: undefined,
                __self: this,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 77,
                  columnNumber: 16
                }
              }))
            );
          } else {
            cov_g3l39j7ue.b[11][1]++;
          }

          cov_g3l39j7ue.s[43]++;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, others, {
              onMouseDown: this.handleMouseDown,
              onMouseUp: this.handleMouseUp,
              value: this.getValue(),
              onFocus: this.handleFocus,
              onBlur: this.handleBlur,
              coin: true,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 79,
                columnNumber: 9
              }
            }))
          );
        }
      }]);

      return Coin;
    }(PureComponent), _class.defaultProps = {
      coin: false
    }, _temp;
  };
});